import React, { useState, useEffect } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp"; // Material-UI icon
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // React Icons
//import logoLargProfOuss from "../assets/images/logo_larg_prof_ouss.png";


const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const services = [
    {
      title: "Voyance et Prédictions",
      description: "Explorez votre avenir avec des prédictions précises.",
      image: "/images/voyance.webp",
    },
    {
      title: "Conseils Spirituels",
      description: "Retrouvez votre équilibre spirituel avec nos conseils.",
      image: "/images/conseils.webp",
    },
    {
      title: "Rituels Personnalisés",
      description: "Des rituels uniques pour vos besoins spécifiques.",
      image: "/images/rituels.webp",
    },
    {
      title: "Retour affectif et voyance",
      description: "Un accompagnement pour restaurer vos relations.",
      image: "/images/retour-affectif.webp",
    },
    {
      title: "Retour immédiat au foyer",
      description: "Pour un retour harmonieux au sein de votre famille.",
      image: "/images/retour-foyer.webp",
    },
    {
      title: "Protection contre les ennemis",
      description: "Mettez-vous à l'abri des énergies négatives.",
      image: "/images/protection.webp",
    },
    {
      title: "Désenvoutement et succès",
      description: "Libérez-vous des obstacles spirituels.",
      image: "/images/desenvoutemen.webp",
    },
    {
      title: "Abandon d’alcool et autres",
      description: "Des solutions pour retrouver une vie saine.",
      image: "/images/abandon-alcool.webp",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % Math.ceil(services.length / 3));
    }, 5000);
    return () => clearInterval(interval);
  }, [services.length]);

  const displayedServices = services.slice(
    currentSlide * 3,
    currentSlide * 3 + 3
  );

  return (
    <div className="home">
      {/* Navbar */}
      <header className="navbar bg-gray-800 text-white py-4 px-6 fixed top-0 w-full shadow-md z-50">
        <div className="container mx-auto flex justify-between items-center">
          {/* Remplacement du texte par le logo */}
          <div className="flex items-center">
          <img
            src="/images/logo_larg_prof_ouss2.png"
            alt="Logo Professeur Ousmane"
            className="h-10"
          />


          </div>



          <nav className="hidden md:flex space-x-6">
            <a href="#about" className="hover:text-green-400">À Propos</a>
            <a href="#services" className="hover:text-green-400">Services</a>
            <a href="#testimonials" className="hover:text-green-400">Témoignages</a>
            <a href="#contact" className="hover:text-green-400">Contact</a>
          </nav>
          <a
            href="#contact"
            className="hidden md:block bg-green-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-green-600"
          >
            Contacter
          </a>
          <button className="block md:hidden text-3xl" onClick={toggleMenu}>
            ☰
          </button>
        </div>
        {isMenuOpen && (
          <div className="bg-gray-900 text-white md:hidden flex flex-col items-center py-4">
            <a href="#about" className="block py-2 px-4 hover:bg-gray-700 rounded" onClick={toggleMenu}>À Propos</a>
            <a href="#services" className="block py-2 px-4 hover:bg-gray-700 rounded" onClick={toggleMenu}>Services</a>
            <a href="#testimonials" className="block py-2 px-4 hover:bg-gray-700 rounded" onClick={toggleMenu}>Témoignages</a>
            <a href="#contact" className="block py-2 px-4 hover:bg-gray-700 rounded" onClick={toggleMenu}>Contact</a>
          </div>
        )}
      </header>


      {/* Hero Section */}
      <section className="hero bg-cover bg-center h-screen relative" style={{ backgroundImage: "url('/images/hero-bg.jpg')" }}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="container mx-auto h-full flex flex-col justify-center items-center text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold">
            Professeur Ousmane : Grand voyant Medium
          </h1>
          <p className="mt-4 text-lg md:text-xl">
            Découvrez nos services de voyance et d'accompagnement pour un avenir prospère et équilibré.
          </p>
          <a href="#services" className="mt-6 bg-green-500 px-6 py-3 rounded-lg shadow-md text-white text-lg hover:bg-green-600">
            Voir Nos Services
          </a>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 bg-gray-100">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">À Propos</h2>
          <p className="mb-6">
            Professeur Ousmane est un expert spirituel dédié à fournir des solutions personnalisées et des conseils pour améliorer votre vie.
          </p>
          <div className="flex flex-col md:flex-row items-center mt-8">
            <img src="/images/professeur.jpg" alt="Professeur Ousmane" className="rounded-lg shadow-lg w-full md:w-1/3" />
            <div className="md:ml-8 mt-6 md:mt-0 text-left">
              <p className="text-gray-700 leading-7">
                Avec des années d'expérience dans l'art de la voyance et des solutions spirituelles, Professeur Ousmane est reconnu pour son approche unique et ses résultats exceptionnels.
              </p>
              <button className="mt-4 bg-green-500 px-4 py-2 rounded-lg text-white hover:bg-green-600">
                Contacter via WhatsApp
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 bg-gray-100 relative">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Nos Services</h2>
          <p className="mb-6">Découvrez les solutions adaptées à vos besoins.</p>
          <div className="relative">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {displayedServices.map((service, index) => (
                <div key={index} className="service-card bg-white p-6 rounded-lg shadow-md hover:shadow-lg relative">
                  <img src={service.image} alt={service.title} className="w-full h-48 object-cover rounded-t-lg mb-4" />
                  <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                  <p className="text-gray-700 mb-4">{service.description}</p>
                  <button className="bg-green-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-green-600">
                    En savoir plus
                  </button>
                </div>
              ))}
            </div>
            <div className="absolute inset-y-0 flex justify-between items-center w-full">
              <button
                onClick={() =>
                  setCurrentSlide((currentSlide - 1 + Math.ceil(services.length / 3)) % Math.ceil(services.length / 3))
                }
                className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
              >
                <FaArrowLeft />
              </button>
              <button
                onClick={() =>
                  setCurrentSlide((currentSlide + 1) % Math.ceil(services.length / 3))
                }
                className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      </section>
      
      {/* Testimonials Section */}
      <section id="testimonials" className="py-16 bg-gray-100">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Témoignages</h2>
          <p className="mb-6">Voici ce que disent nos clients.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="testimonial-card bg-white p-6 rounded-lg shadow-md hover:shadow-lg">
              <p className="text-gray-700">"Professeur Ousmane m'a aidé à trouver des solutions à mes problèmes."</p>
              <p className="mt-4 font-bold">- Client Satisfait</p>
            </div>
            <div className="testimonial-card bg-white p-6 rounded-lg shadow-md hover:shadow-lg">
              <p className="text-gray-700">"Un service professionnel et des résultats garantis. Merci encore !"</p>
              <p className="mt-4 font-bold">- Une Cliente Heureuse</p>
            </div>
            <div className="testimonial-card bg-white p-6 rounded-lg shadow-md hover:shadow-lg">
              <p className="text-gray-700">"L'accompagnement que j'ai reçu a transformé ma vie. Un grand merci !"</p>
              <p className="mt-4 font-bold">- Jean Dupont</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 bg-gray-100">
        <div className="container mx-auto text-center md:flex md:justify-between">
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-4">Contactez-Nous</h2>
            <p className="mb-6">
              <strong>Email :</strong> professeurousmane072@gmail.com
              <br />
              <strong>Téléphone :</strong> +33 06-08-99-05-42
              <br />
              <strong>WhatsApp :</strong> +33 06-08-99-05-42
            </p>
            <button onClick={togglePopup} className="bg-green-500 px-6 py-3 rounded-lg shadow-md text-white hover:bg-green-600">Prendre un Rendez-vous</button>
          </div>
          <div className="md:w-1/2 mt-6 md:mt-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.9996816880984!2d2.2944816156738665!3d48.8588440792877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66fdbd4b1d1a3%3A0x42031d54e8f5c8c!2sEiffel%20Tower!5e0!3m2!1sen!2sfr!4v1614556321744!5m2!1sen!2sfr"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-6 text-center">
        <p>© 2024 Professeur Ousmane. Tous droits réservés.</p>
        <p>Développé par <a href="https://www.findacorps.com" className="text-green-400">Finda Corps</a>.</p>
      </footer>

      {/* Back to Top */}
      <button onClick={scrollToTop} className="fixed bottom-6 right-6 bg-gray-800 p-3 rounded-full text-white">↑</button>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/33608990542"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 bottom-20 bg-green-500 text-white p-4 rounded-full shadow-lg flex items-center justify-center"
      >
        <WhatsAppIcon fontSize="large" />
      </a>

      {/* Popup Form */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full relative">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
              onClick={togglePopup}
            >
              ✕
            </button>
            <h3 className="text-xl font-bold mb-4">Planifier un Rendez-vous</h3>
            <form>
              <input type="text" placeholder="Nom" className="w-full p-2 mb-4 border rounded" />
              <input type="email" placeholder="Email" className="w-full p-2 mb-4 border rounded" />
              <input type="tel" placeholder="Téléphone" className="w-full p-2 mb-4 border rounded" />
              <textarea placeholder="Détails de vos besoins" className="w-full p-2 mb-4 border rounded"></textarea>
              <button type="submit" className="bg-green-500 px-4 py-2 text-white rounded hover:bg-green-600">Envoyer</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
